import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { UserStatus } from './enums/UserStatus';

export class DownlineReportPaginated {
  @Type(() => DownlineUser)
  data: DownlineUser[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  constructor(data: DownlineUser[], nextPageUrl?: string) {
    this.data = data;
    this.nextPageUrl = nextPageUrl;
  }

  get cursor(): string | null {
    return this.nextPageUrl
      ? new URL(this.nextPageUrl).searchParams.get('page')
      : null;
  }

  static fromJson(json: Record<string, any>): DownlineReportPaginated {
    return plainToInstance(DownlineReportPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class DownlineUser {
  id: number;

  @Expose({ name: 'parent_id' })
  parentId: number;

  @Expose({ name: 'sponsor_username' })
  sponsorUsername?: string;

  @Expose({ name: 'placement_username' })
  placementUsername?: string;

  status: UserStatus;

  email: string;

  username: string;

  avatar?: string;

  pv: string;

  tv: string;

  cv: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  @Expose({ name: 'rank_id' })
  rankId?: number;

  @Expose({ name: 'rank_name' })
  rankName?: string;

  @Expose({ name: 'rank_icon' })
  rankIcon?: string;

  @Expose({ name: 'first_name' })
  firstname: string;

  @Expose({ name: 'last_name' })
  lastname?: string;

  level: number;

  @Expose({ name: 'total_earnings' })
  totalEarnings: string;

  @Expose({ name: 'total_left' })
  leftPoints?: string;

  @Expose({ name: 'total_right' })
  rightPoints?: string;

  @Expose({ name: 'carry_left' })
  leftCarry?: string;

  @Expose({ name: 'carry_right' })
  rightCarry?: string;

  constructor(
    id: number,
    parentId: number,
    sponsorUsername: string | undefined,
    placementUsername: string | undefined,
    status: UserStatus,
    email: string,
    username: string,
    avatar: string | undefined,
    pv: string,
    tv: string,
    cv: string,
    dateCreated: Date,
    rankId: number | undefined,
    rankName: string | undefined,
    rankIcon: string | undefined,
    firstname: string,
    lastname: string | undefined,
    level: number,
    totalEarnings: string,
    leftPoints: string | undefined,
    rightPoints: string | undefined,
    leftCarry: string | undefined,
    rightCarry: string | undefined
  ) {
    this.id = id;
    this.parentId = parentId;
    this.sponsorUsername = sponsorUsername;
    this.placementUsername = placementUsername;
    this.status = status;
    this.email = email;
    this.username = username;
    this.avatar = avatar;
    this.pv = pv;
    this.tv = tv;
    this.cv = cv;
    this.dateCreated = dateCreated;
    this.rankId = rankId;
    this.rankName = rankName;
    this.rankIcon = rankIcon;
    this.firstname = firstname;
    this.lastname = lastname;
    this.level = level;
    this.totalEarnings = totalEarnings;
    this.leftPoints = leftPoints;
    this.rightPoints = rightPoints;
    this.leftCarry = leftCarry;
    this.rightCarry = rightCarry;
  }

  static fromJson(json: Record<string, any>): DownlineUser {
    return plainToInstance(DownlineUser, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
